import { CheckIcon } from '@heroicons/react/20/solid'
import { useNavigate } from "react-router-dom";

const plans = [
  {
    name: 'Hourly Booking',
    id: 'plan-hour',
    href: '#',
    type:"/ Hour",
    priceMonthly: '₹275',
    description: 'Book according to your needs for per hour',
    features: ['Flexible Timings', 'No Long Term Commitments', 'Based on Availability'],
  },
  {
    name: 'Monthly Membership',
    id: 'plan-monthly',
    href: '#',
    type:"/Month per member",
    priceMonthly: '₹1100',
    description: 'Best for players who want intensive training and priority access throughout a month',
    features: ['Monday to Friday Session', 'Flexible Timing', 'Dedicated coach assistance'],
    featured: true, // Center plan emphasized
  },
  {
    name: 'Weekend Membership',
    id: 'plan-weekend',
    href: '#',
    type:"/Month per member",
    priceMonthly: '₹500',
    description: 'Weekend Sessions',
    features: ['Saturday and Sunday Session', 'Flexible Timing', 'Dedicated coach assistance', 'Group Discounts for teams of 6 or more'],
  },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Pricing() {
  const navigate = useNavigate();
  return (
    <div id='pricing' className="relative isolate bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="mx-auto max-w-4xl text-center">
        <h2 className="text-base font-semibold text-indigo-600">Membership Plans</h2>
        <p className="mt-2 text-5xl font-semibold tracking-tight text-gray-900 sm:text-6xl">
          Choose the best plan for your training
        </p>
      </div>
      <p className="mx-auto mt-6 max-w-2xl text-center text-lg text-gray-600 sm:text-xl">
        Pick a membership plan that suits your training needs and take your badminton skills to the next level.
      </p>

      {/* Three plans in a single row */}
      <div className="mx-auto mt-16 grid max-w-6xl grid-cols-1 gap-6 sm:mt-20 lg:grid-cols-3">
        {plans.map((plan) => (
          <div
            key={plan.id}
            className={classNames(
              plan.featured
                ? 'relative bg-gray-900 text-white shadow-2xl scale-105 z-10 p-10'  // Center plan emphasized
                : 'bg-white/60 ring-1 ring-gray-900/10',
              'rounded-3xl p-8 shadow-lg transition-transform duration-300'
            )}
          >
            <h3 className={classNames(plan.featured ? 'text-indigo-400' : 'text-indigo-600', 'text-lg font-semibold')}>
              {plan.name}
            </h3>
            <p className="mt-4 flex items-baseline gap-x-2">
              <span className={classNames(plan.featured ? 'text-white' : 'text-gray-900', 'text-5xl font-semibold')}>
                {plan.priceMonthly}
              </span>
              <span className={classNames(plan.featured ? 'text-gray-400' : 'text-gray-500', 'text-base')}>
                {plan.type}
              </span>
            </p>
            <p className={classNames(plan.featured ? 'text-gray-300' : 'text-gray-600', 'mt-6 text-base')}>
              {plan.description}
            </p>
            <ul className={classNames(plan.featured ? 'text-gray-300' : 'text-gray-600', 'mt-8 space-y-3 text-sm')}>
              {plan.features.map((feature) => (
                <li key={feature} className="flex gap-x-3">
                  <CheckIcon className={classNames(plan.featured ? 'text-indigo-400' : 'text-indigo-600', 'h-6 w-5')} />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <br></br>
      <div className="mt-6 flex items-center justify-center space-y-4 m-4">
              <button
                onClick={() => navigate("/membership")}
                className="mt-4 bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition"
              >
                Go to Membership
              </button> <br></br>
              
      </div>
      <p className='text-black flex justify-center'>To book your slot now</p>
      <div className='flex justify-center mt-10'>
            <a
              href="https://wa.me/+918100376761"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-md bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500"
            >
              <img src="/whatsapp_icon.png" alt="WhatsApp" className="w-5 h-5" /> 
              Book Your Membership on WhatsApp Now
            </a>
      </div>
    </div>
  )
}
